import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";
import SpinnerNew from "~/components/SpinnerNew";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import {
  createNewCadernoEncargos,
  errorCadernoEncargos,
  setUpdateEncargo,
  setCreateEncargo,
  getCadernosEncargos,
  updateEncargo,
} from "~/store/ducks/cvManagement/actionTypes";
import {
  Form,
  Card,
  OverlayTrigger,
  Tooltip,
  Button,
  Badge,
  Row,
  Col,
  Modal,
} from "react-bootstrap";
import pdfPreview from "~/assets/img/datacapture/pdf_preview.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import { abbreviateString } from "~/utils";
import DocumentPreview from "./DocumentPreview";
import { setCadernosEncargos } from "~/store/ducks/cvManagement/actionTypes";
import uuid from "uuid";
import CadernoEncargosCreatePreview from "./CadernoEncargosCreatePreview";

const ModalNew = ({
  show,
  onClose,
  isMobile,
  rowSelectedCadernoEncargos,
  cadernosEncargosData,
  indexProfiles,
  t,
}) => {
  const [fileDataSelected, setFileDataSelected] = useState({});
  const [onDragOver, setOnDragOver] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [docBase64, setDocBase64] = useState("");
  const [alertShow, setAlertShow] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const maxFileSize = 1024 * 1024 * 15; //15 Mb

  const [buttonToEdit, setButtonToEdit] = useState(false);
  const { user } = useSelector((state) => state.globalReducer);
  const dispatch = useDispatch();
  const {
    cadernoEncargosData,
    isLoadingCadernoEncargosData,
    errorCadernoEncargosShow,
    errorCadernoEncargosMessage,
    isLoadingSpecificEncargo,
    updatedEncargo,
    updatedEncargoMsg,
    createEncargo,
    createEncargoMsg,
  } = useSelector((state) => state.cvManagementReducer);
  const inputFile = useRef(null);
  useEffect(() => {
    if (Object.keys(rowSelectedCadernoEncargos).length > 0) {
      setButtonToEdit(true);
      setFileDataSelected(rowSelectedCadernoEncargos);
      setDocBase64(rowSelectedCadernoEncargos?.docBase64);
      dispatch(setUpdateEncargo(false, ""));
      dispatch(setCreateEncargo(false, ""));
    }
  }, [rowSelectedCadernoEncargos]);

  useEffect(() => {
    if (cadernoEncargosData) {
      setFileDataSelected(cadernoEncargosData);
    }
  }, [cadernoEncargosData]);

  useEffect(() => {
    if (createEncargo) {
      if (createEncargoMsg === "success") handleClose();
      setAlertShow(true);
      setAlertMessage(
        createEncargoMsg === "success"
          ? "Caderno de Encargo adicionado com sucesso"
          : "Não foi possível adicionar o Caderno de Encargo"
      );
      setAlertType(createEncargoMsg);
    }
  }, [createEncargo]);

  useEffect(() => {
    if (updatedEncargo) {
      if (updatedEncargoMsg === "success") handleClose();
      setAlertShow(true);
      setAlertMessage(
        updatedEncargoMsg === "success"
          ? "Caderno de Encargo atualizado com sucesso"
          : "Não foi possível atualizar o Caderno de Encargo"
      );
      setAlertType(updatedEncargoMsg);
    }
  }, [updatedEncargo]);

  const handleClose = () => {
    setFileDataSelected({});
    setAlertShow(false);
    setAlertMessage("");
    setAlertType("");
    setDocuments([]);
    setDocBase64("");
    dispatch(errorCadernoEncargos(false, ""));
    dispatch(setUpdateEncargo(false, ""));
    dispatch(setCreateEncargo(false, ""));
    setButtonToEdit(false);
    if (inputFile.current) {
      inputFile.current.value = "";
    }
    onClose();
  };

  const handleOnChoose = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile.type === "application/pdf") {
      handleMultipleFiles([selectedFile]);
    }
  };

  const handleOnDrop = (event) => {
    setOnDragOver(false);
    const files_ = event.dataTransfer.files;
    const files = [];
    for (let i = 0; i < files_?.length; i++) {
      files.push(files_.item(i));
    }
    handleMultipleFiles(files);
    event.preventDefault();
  };

  const handleMultipleFiles = (files) => {
    let totalfilesize = files.reduce(
      (accumulator, currentValue) => accumulator + currentValue.size,
      0
    );
    if (totalfilesize > maxFileSize) {
      return;
    }
    setDocuments(files);
  };

  const handleClick = () => {
    inputFile.current.click();
  };

  const handleRemoveFile = () => {
    setDocuments([]);
    setFileDataSelected({});
    setDocBase64("");
    if (inputFile.current) {
      inputFile.current.value = "";
    }
  };

  const handleSave = () => {
    const docList = [];
    documents.forEach((document, index, array) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        docList.push({
          file: e.target.result,
        });
        if (index === array?.length - 1) {
          if (docList?.length > 0) {
            const base64String = docList[0].file.split("base64,")[1];
            let payload = {
              userId: user.id,
              organizationId: user.organization.id,
              base64: base64String,
              filetype: documents[0].type,
              filename: documents[0].name,
            };
            setDocBase64(base64String);
            dispatch(createNewCadernoEncargos(payload));
          }
          setDocuments([]);
        }
      };
      reader.readAsDataURL(document);
    });
  };

  const getPreviewImage = () => {
    const file = documents[0];
    if (file) {
      return file.type === "application/pdf"
        ? pdfPreview
        : URL.createObjectURL(file);
    } else {
      return document.filetype === "application/pdf"
        ? pdfPreview
        : "data:image/jpg;base64," + document.data;
    }
  };

  const handleConfirm = () => {
    const fileToSave = {
      ...fileDataSelected[0],
      docBase64,
      id: uuid(),
      estado: 1,
    };
    dispatch(setCadernosEncargos((prevState) => [...prevState, fileToSave]));
    handleClose();
  };

  const handleSaveEdit = async () => {
    if (!fileDataSelected?.id) return;
    await dispatch(updateEncargo(fileDataSelected));
    dispatch(getCadernosEncargos());
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertShow(false);
    setAlertMessage("");
    setAlertType("");
    dispatch(errorCadernoEncargos(false, ""));
    dispatch(setUpdateEncargo(false, ""));
    dispatch(setCreateEncargo(false, ""));
  };

  return (
    <>
      <SpinnerNew
        open={isLoadingCadernoEncargosData || isLoadingSpecificEncargo}
      />
      <Snackbar
        open={alertShow}
        autoHideDuration={5000}
        onClose={handleCloseAlert}
      >
        <Alert
          onClose={handleCloseAlert}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="custom-modal modal-80w"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {buttonToEdit ? "Editar Encargo" : "Novo Encargo"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!Object.keys(fileDataSelected).length > 0 ? (
            <>
              <div
                style={{
                  margin: "0px 0px 2rem",
                  width: "100%",
                  alignSelf: isMobile ? "auto" : "center",
                }}
              >
                <div
                  style={{
                    display:
                      !isMobile && documents && documents?.length > 0
                        ? "flex"
                        : "",
                    placeItems:
                      documents && documents?.length === 0 && "center",
                  }}
                >
                  <div
                    className="dropAreaExpenses"
                    onDrop={(e) => handleOnDrop(e)}
                    onClick={() => handleClick()}
                    onDragEnter={() => setOnDragOver(true)}
                    onDragLeave={() => setOnDragOver(false)}
                    style={
                      onDragOver
                        ? { background: "#fff" }
                        : { background: "#efefef" }
                    }
                  >
                    <span>
                      <i className={"icon-submit portal-image-upload-icon"} />
                      <div
                        className={"portal-label-main"}
                        style={{ padding: "2rem" }}
                      >
                        {t("portalrh.documentManagement.dropToUpload")}
                      </div>
                    </span>
                    <input
                      multiple={false}
                      id="file"
                      type="file"
                      ref={inputFile}
                      style={{ display: "none" }}
                      onChange={(e) => handleOnChoose(e)}
                      accept=".pdf"
                    />
                  </div>
                  {isMobile && (
                    <div className="dc-label">
                      {t("portalrh.documentManagement.totalFileSize") +
                        " 15 Mb"}
                    </div>
                  )}
                  <div
                    style={{
                      display: "inline-block",
                      width: isMobile ? "100%" : "50%",
                      textAlignLast: "center",
                      marginTop: isMobile ? "1rem" : "",
                      height: "0px",
                    }}
                  >
                    {documents && documents?.length > 0 && (
                      <h6 style={{ placeContent: "center", padding: "0px" }}>
                        {t("openai.expenseLoaded")}
                      </h6>
                    )}
                    {documents && documents?.length > 0 && (
                      <>
                        <img
                          src={getPreviewImage()}
                          className={"portal-image-preview-one"}
                          alt="preview"
                        />
                        <CancelIcon color="error" onClick={handleRemoveFile} />
                        <OverlayTrigger
                          key="bottom"
                          placement="bottom"
                          overlay={<Tooltip>{documents[0].name}</Tooltip>}
                        >
                          <small>
                            {abbreviateString(documents[0].name, 28)}
                          </small>
                        </OverlayTrigger>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : buttonToEdit ? (
            <DocumentPreview
              fileSelected={fileDataSelected}
              setFileSelected={setFileDataSelected}
            />
          ) : (
            <CadernoEncargosCreatePreview
              fileSelected={fileDataSelected}
              setFileSelected={setFileDataSelected}
              base64={docBase64}
            />
          )}
        </Modal.Body>{" "}
        <Modal.Footer>
          {buttonToEdit ? (
            <>
              <Button
                id="button_cvmanagement_cadernosEncargos_modal_index_save"
                className="card-button"
                onClick={indexProfiles}
              >
                Indexar CV's
              </Button>
              <Button
                id="button_cvmanagement_cadernosEncargos_modal_close_edit"
                variant="danger"
                style={{ minHeight: "44px" }}
                onClick={handleClose}
              >
                Fechar
              </Button>
              {/* <Button
                id="button_cvmanagement_cadernosEncargos_modal_save_edit"
                className="card-button"
                onClick={handleSaveEdit}
              >
                Gravar
              </Button> */}
            </>
          ) : !Object.keys(fileDataSelected).length > 0 ? (
            <>
              <Button
                id="button_cvmanagement_cadernosEncargos_modal_close_nofile"
                variant="danger"
                style={{ minHeight: "44px" }}
                onClick={handleClose}
              >
                Fechar
              </Button>
              <Button
                id="button_cvmanagement_cadernosEncargos_modal_save_nofile"
                className="card-button"
                onClick={handleSave}
                disabled={
                  documents.length === 0 ||
                  (documents.length > 0 && documents[0].size > maxFileSize)
                }
              >
                Extrair
              </Button>
            </>
          ) : (
            <>
              <Button
                id="button_cvmanagement_cadernosEncargos_modal_close"
                variant="danger"
                style={{ minHeight: "44px" }}
                onClick={handleClose}
              >
                Fechar
              </Button>
              {/* <Button
                id="button_cvmanagement_cadernosEncargos_modal_remove"
                variant="danger"
                style={{ minHeight: "44px" }}
                onClick={handleRemoveFile}
              >
                Remover Ficheiro
              </Button>
              <Button
                id="button_cvmanagement_cadernosEncargos_modal_save"
                className="card-button"
                onClick={handleConfirm}
              >
                Confirmar
              </Button> */}
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withNamespaces()(ModalNew);
